import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { ApplicationStateContext } from "../contexts";

const useAds = () => {
  const location = useLocation();
  const { applicationState, applicationStateDispatch } = useContext(ApplicationStateContext);

  /** Effect: Load the ads though Google Tag Manager.
   */
  useEffect(() => {
    // No ads on the testing views.
    if (location.pathname.includes("testing")) {
      return;
    }

    // Only load them once.
    if (applicationState.loadedAds) {
      return;
    }

    // Fire up Google Tag Manager.
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-T6SRVZK");

    // GTM migration
    (function (w, e) {
      var s = new XMLHttpRequest();
      s.open(
        "GET",
        "https://api.enthusiastgaming.net/scripts/cdn.enthusiast.gg/script/eg-aps/release/eg-aps-bootstrap-v2.0.0.bundle.js?site=systemrequirementslab.com",
        !0
      );
      s.onreadystatechange = function () {
        var t;
        let x =
          4 == s.readyState &&
          ((200 <= s.status && s.status < 300) || 304 == s.status) &&
          (((t = e.createElement("script")).type = "text/javascript"),
          (t.text = s.responseText),
          e.head.appendChild(t));
      };
      s.send(null);
    })(window, document);

    // Set the ad state.
    applicationStateDispatch({ type: "set" });
  }, [applicationState.loadedAds, applicationStateDispatch, location.pathname]);
};

export default useAds;
